import { BOOKING_GA_CATEGORIES, BookingPathKeys } from '../../paths';

export const APPOINTMENT_INFO_STRINGS = {
    PageTitle: 'Zocdoc | Booking | Start',
    FormTitle: 'Appointment Info',
    ChooseYourInsurance: 'Choose your insurance',
    Insurance: 'Insurance',
    Continue: 'Continue',
    Reschedule: 'Reschedule',
    RescheduleTitle: 'Reschedule this appointment:',
    AppointmentTime: 'Appointment Time',
    ResourceConstraintOkButtonText: 'Book this appointment',
    ResourceConstraintCancelButtonText: 'No thanks',
    VisitReasonPrompt: `What's the reason for your visit?`,
    ProcedureMayNotBeCovered:
        "This procedure isn't always covered by insurance companies. Check with yours to know for sure.",
};

export const buildResourceConstraintMessage = (professionalName) =>
    `This appointment is with a healthcare professional under the supervision of ${professionalName}. You may not be seen directly by ${professionalName}.`;

export const buildHaveYouSeenMessage = (professionalName) =>
    `Have you seen ${professionalName} before?`;

export const APPOINTMENT_INFO_GA_CATEGORY = 'Booking - Appt Info';
export const REVIEW_GA_CATEGORY =
    BOOKING_GA_CATEGORIES[BookingPathKeys.appointmentInfoPath];

const cardCaptureEvents = {
    trackCardCaptureEligibleAtBooking: 'Card Capture Eligible At Booking',
    trackInsuranceCardAttachedWithBooking:
        'Insurance Card Attached With Booking',
};

export const GaActionText = {
    trackMadeItToBookingFlow: 'Made it to Booking Flow',
    trackChangeToExistingPatient: 'Changed to existing patient',
    trackChangeToNewPatient: 'Changed to new patient',
    trackIsNewPatient: 'Is A New Patient Of This Doctor',
    trackHasSeenThisDoctorBefore: 'Has Seen This Doctor Before',
    trackDisplaySelectNewTimePointer: 'Display select a new time pointer',
    trackProcedureMayNotBeCoveredTooltipDisplayed: 'Tooltip displayed',
    trackSelectAppointmentTime: 'Select Appointment Time',
    trackChangeAppointmentTimeClick: 'Change Appointment Time Click',
    trackClickContinue: 'Click Continue',
    trackProcedurePickerClick: 'Procedure Picker Click',
    trackProcedurePickerSelection: 'Procedure Picker Selection',
    trackInsurancePickerClick: 'Insurance Picker Click',
    trackInsuranceCarrierClick: 'Insurance Carrier Click',
    trackInsurancePlanClick: 'Insurance Plan Click',
    ...cardCaptureEvents,
};
